import * as React from 'react';
export const multibancoSvg = React.forwardRef(function multibancoSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.566 16H1.434c-1.51 0-1.524-1.383-1.37-2.207.083-.555.988-.55 1.087 0v.643c0 .294.231.535.513.535h12.671c.283 0 .514-.24.514-.535v-.643c.1-.55 1.004-.555 1.088 0 .153.824.138 2.207-1.37 2.207zM12.964 0h.511c.716 0 1.302.326 1.302 1.115v.686c0 .97-1.26.966-1.26.007v-.375A.426.426 0 0 0 13.1 1H2.89a.426.426 0 0 0-.416.433V1.8c0 .964-1.202.957-1.202.02v-.705C1.271.326 1.857 0 2.573 0h.712zm1.556 7.882a2.103 2.103 0 0 1 1.193 1.879c0 1.155-.969 2.1-2.153 2.1h-3.318a.56.56 0 0 1-.565-.55V4.735c0-.317.25-.577.555-.577h2.764c1.163 0 2.115.99 2.115 2.201a2.24 2.24 0 0 1-.591 1.523zm-2.477-.536h1.054v-.012c.48-.077.85-.511.85-1.032 0-.574-.45-1.043-1.002-1.043h-2.122v5.457h2.691c.57 0 1.035-.485 1.035-1.078s-.466-1.078-1.035-1.078h-.417l-1.054-.002a.596.596 0 0 1-.582-.606c0-.333.262-.606.582-.606zM9.15 11.205a.687.687 0 0 1-.592.763.673.673 0 0 1-.732-.617l-.546-5.23-1.933 5.114-.002.005-.005.014-.005.01v.003l-.005.011-.008.016-.002.005-.005.01a.693.693 0 0 1-.137.187l-.012.012a.66.66 0 0 1-.115.085l-.003.001-.013.007-.012.007-.005.003-.016.007-.007.004-.008.003-.007.004-.013.005-.01.004-.008.003a.652.652 0 0 1-.2.04H4.7a.64.64 0 0 1-.218-.047l-.009-.004-.011-.004-.009-.004-.007-.004-.007-.003-.013-.007-.012-.006-.011-.007-.006-.003a.664.664 0 0 1-.102-.074l-.003-.002-.022-.02a.655.655 0 0 1-.017-.017l-.016-.018a.768.768 0 0 1-.02-.023l-.002-.003a.692.692 0 0 1-.07-.106l-.004-.006-.005-.01-.007-.015-.002-.004-.004-.009-.004-.008-.003-.007-.004-.009-.003-.009-.005-.012L2.17 6.122l-.546 5.23a.673.673 0 0 1-.732.616.687.687 0 0 1-.592-.763l.643-6.166.001-.004a1.167 1.167 0 0 1 .124-.414A1.105 1.105 0 0 1 2.1 4.012h.002c.072.004.14.013.202.028.344.084.636.333.774.697l1.647 4.357L6.37 4.737a1.11 1.11 0 0 1 .774-.697 1.083 1.083 0 0 1 .409-.018c.362.052.664.277.828.599a1.181 1.181 0 0 1 .124.414v.003z',
      fillRule: 'evenodd',
    }),
  );
});
multibancoSvg.defaultProps = {
  height: '16',
  viewBox: '0 0 16 16',
  width: '16',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var multibanco = {
  category: 'paymentmethod',
  colorable: true,
  name: 'multibanco',
  svg: multibancoSvg,
};
